import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Radio, FormControlLabel, RadioGroup, FormLabel
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContractorMemo, fetchCuttingList, fetchCuttingReturnlist, fetchCuttingReturnlist2 } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { errorStyles } from '../../Utils/table';
import { fetchReturnMemoNo, fetchStitchEmplist, fetchStitchMemoNo, StitchingEntry } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchEmplist, selectStitchingMemoNo, selectCuttingReturnMemo } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { StitchEntrylist } from '../TitleList';
import { selectContractorMemo, selectCutReturnlist, selectItemMaterialData } from '../Selectors/Master/ItemSelectors';
import { fetchItemMaterialData } from '../../Store/PHPSlice/Item';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { Preview } from '@mui/icons-material';
import Dropdown from '../FieldsComponents/Dropdown';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';

const StitchContEntry2 = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        reId: '',
        ordType: '0',
        stitchNo: '',
        reMemo: '',
        reMemoNo: '',
        sono: '',
        soId: '',
        partyId: '',
        partyNm: '',
        schlId: '',
        schlNm: '',
        empNm: '',
        empType: '2',
        item: '',
        itemId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        totQty: '',
        instructions: '',
        kaje_sts: '0',
        totmat: '',
        cutMemo: '',
        cutrememo: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [material, setMaterial] = useState([]);
    const [itemData, setItemData] = useState([]);
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData?.length).fill('0'));
    const [issueQtyValues, setIssueQtyValues] = useState(Array(itemData?.length).fill('0'));
    const [allData, setAllData] = useState([]);
    const [reMemolist, setReMemolist] = useState([]);
    const [itemsSO, setItemSO] = useState([]);

    const actionMap = {
        master: fetchCuttingList
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const returnMemo = useSelector(selectCuttingReturnMemo);
    const stemplist = useSelector(selectStitchEmplist);
    const stMemoNo = useSelector(selectContractorMemo);
    const cutReturndata = useSelector(selectCutReturnlist);
    const materiallist = useSelector(selectItemMaterialData);
    // console.log(reMemolist);

    useEffect(() => {
        dispatch(fetchReturnMemoNo());
        dispatch(fetchStitchEmplist());
        dispatch(fetchContractorMemo());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (stMemoNo.data) {
            const item = stMemoNo.data.con_memo;
            setFormData(prev => ({
                ...prev,
                stitchNo: item
            }))
        }
    }, [stMemoNo]);


    useEffect(() => {
        if (cutReturndata?.data?.length > 0) {
            const item = cutReturndata.data[0];
            dispatch(fetchItemMaterialData(item?.itemId));
            const mulrememo = cutReturndata?.returnInfo?.map(item => item.ctreMemo);
            const sinlgememo = mulrememo?.join(',');
            setFormData(prev => ({
                ...prev,
                reId: item.ctId,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                m1cloth: item.m1cloth,
                m1clothNm: item.m1clothNm,
                m2cloth: item.m2cloth,
                m2clothNm: item.m2clothNm,
                m3cloth: item.m3cloth,
                m3clothNm: item.m3clothNm,
                soId: item.soId,
                sono: item.sono,
                partyId: item.partyId,
                partyNm: item.partyNm,
                schlId: item.schoolId,
                schlNm: item.schoolNm,
                empType: item.empType,
                cutMemo: item.ctMemo,
                cutrememo: sinlgememo
            }));
        }
        if (cutReturndata?.returnInfo?.length > 0) {
            const item = cutReturndata.returnInfo2;
            setItemData(item);
        }
    }, [cutReturndata]);

    useEffect(() => {
        if (returnMemo?.itemlist?.length > 0) {
            const values = returnMemo?.itemlist;
            setReMemolist(values);
        }
    }, []);

    const isDesktop = useMediaQuery('(min-width:768px)');

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'reMemo':
                if (value) {
                    // dispatch(fetchCuttingReturnlist(value));
                    dispatch(fetchCuttingReturnlist2(value));
                } else {
                    setItemData([]);
                    setFormData({
                        sono: '',
                        soId: '',
                        partyId: '',
                        partyNm: '',
                        schlId: '',
                        schlNm: '',
                        item: '',
                        itemId: '',
                        mcloth: '',
                        m1cloth: '',
                        m2cloth: '',
                        m3cloth: '',
                        mclothNm: '',
                        m1clothNm: '',
                        m2clothNm: '',
                        m3clothNm: '',
                        ordType: '0'
                    })
                }
                break;
            case 'sono':
                if (value) {
                    const data = {
                        sono: value,
                        empType: '1'
                    }
                    fetchSOwiseItems(data);
                }
                break;
            default:
                break;
        }
    };


    const fetchSOwiseItems = async (id) => {
        const { sono, empType } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getItems_StitchSaleOrder&sono=${sono}&empType=${empType}`);
            setItemSO(response.data.data);
            // console.log(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleQtyChange = (type, index, value) => {
        // Allow only numeric values
        if (/^\d*$/.test(value)) {
            let updatedValues;
            switch (type) {
                case 'issue':
                    // Ensure value is not greater than itemData value
                    if (parseInt(value, 10) <= itemData[index].rbqty) {
                        updatedValues = [...issueQtyValues];
                        updatedValues[index] = value;
                        setIssueQtyValues(updatedValues);
                        const tot = updatedValues?.reduce((acc, sum) => acc + parseFloat(sum), 0);
                        setFormData(prev => ({
                            ...prev,
                            totQty: tot
                        }));

                        // Update balance values based on the new issue quantity
                        const newBalQtyValues = [...balQtyValues];
                        newBalQtyValues[index] = itemData[index].rbqty - parseInt(value, 10);
                        setBalQtyValues(newBalQtyValues);
                    } else {
                        alert(`Entered value cannot be greater than ${itemData[index].rbqty}`);
                    }
                    break;
                default:
                    break;
            }
        }
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const handleAddlump = () => {
        const materialdata = {
            ID: 0,
            materialNm: '',
            qty: '',
            selected: false
        };
        setMaterial((prevRows) => [...prevRows, materialdata]);
        setFormData(prev => ({
            ...prev,
            material: ''
        }));
    };

    const handleLumpSelection = (index) => {
        const newRows = [...material];
        newRows[index].selected = !newRows[index].selected;
        setMaterial(newRows);
    };

    const handleRemoveLumps = () => {
        const filteredRows = material.filter((row) => !row.selected);
        setMaterial(filteredRows);

        // const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        // setLumpTotMtr(totmtr);
    };

    const handlenavigateMaterial = () => {
        window.open(`/new-material-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDropdownChange2 = (matIndex, newValue) => {
        if (newValue == null) {
            alert('Set the item material In Item Master');
        }
        setMaterial((prevMaterials) => {
            const updatedMaterials = [...prevMaterials];
            if (!updatedMaterials[matIndex]) return updatedMaterials;

            // Update the specific material name
            updatedMaterials[matIndex] = {
                ...updatedMaterials[matIndex],
                material: newValue?.ID || '',
                materialNm: newValue?.materialNm || '',
                qty: newValue?.qty || ''
            };
            return updatedMaterials;
        });
    };

    const handleLumpColor = (index, value, name) => {
        const updatematerial = [...material];
        updatematerial[index][name] = value;
        setMaterial(updatematerial);
        const totmtqty = updatematerial.reduce((acc, qty) => acc + parseFloat(qty.qty), 0);
        setFormData(prev => ({
            ...prev,
            totmat: totmtqty || 0
        }));
    };


    const handleAddData = () => {

        if (formData.empNm === "") {
            alert("Select Master");
        } else if (itemData?.length === 0) {
            alert("Select Cutting Item");
        } else {
            const selectMemo = returnMemo?.data?.find(item => item.ctreMemo === formData.reMemo);
            const memo = selectMemo?.Memo;

            const mulvalues = {
                reId: formData.reId,
                reMemo: formData.reMemo,
                itemNm: formData.item,
                itemId: formData.itemId,
                mcloth: formData.mcloth,
                mclothNm: formData.mclothNm,
                m1cloth: formData.m1cloth,
                m1clothNm: formData.m1clothNm,
                m2cloth: formData.m2cloth,
                m2clothNm: formData.m2clothNm,
                m3cloth: formData.m3cloth,
                m3clothNm: formData.m3clothNm,
                instruction: formData.instructions,
                itemSize: itemData,
                materials: material,
                issqty: issueQtyValues,
                balqty: balQtyValues,
                totqty: formData.totQty,
                totmat: formData.totmat,
                ctqty: itemData.map(item => item.rqty),
                size: itemData.map(item => item.size),
                // memo: memo,
                cutMemo: formData.cutMemo,
                cutrememo: formData.cutrememo,
                sono: formData.sono,
                ordType: formData.ordType
            };
            const filterRememo = reMemolist?.filter(item => item.ctreMemo !== formData.reMemo);
            setReMemolist(filterRememo);
            setAllData(prev => [...prev, mulvalues]);
            setItemData([]);
            setMaterial([]);
            setFormData(prev => ({
                ...prev,
                reMemo: '',
                item: '',
                itemId: '',
                mcloth: '',
                mclothNm: '',
                m1cloth: '',
                m1clothNm: '',
                m2cloth: '',
                m2clothNm: '',
                m3cloth: '',
                m3clothNm: '',
                instructions: '',
                totQty: '',
                totmat: '',
                reId: '',
                cutrememo: '',
                cutMemo: '',
                sono: ''
            }));
            setIssueQtyValues([]);
            setBalQtyValues([]);
        }
    };

    const handleDeleteItem = (data) => {

        const updatedData = allData?.filter(item => item !== data);
        setAllData(updatedData);
    };

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/stitching-item-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    function convertIntoOneObject(formData, allData) {
        const data = {
            dt: formData.dt,
            stMemo: formData.stitchNo,
            empId: formData.empNm,
            empType: formData.empType,
            allData: allData,
            userId: formData.userId
        };
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const finalObject = convertIntoOneObject(formData, allData);
        // console.log(finalObject);

        dispatch(StitchingEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Stitching Added");
                alert("Stitching Added");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };


    // console.log(reMemolist);

    const handleEmployeetNew = () => {
        window.open(`/new-employee-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistMaster = [
        {
            label: 'Master',
            id: 'empNm',
            options: stemplist?.data2 || [],
            value: formData.empNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleEmployeetNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('empNm'),
            handleDropdownClose: () => handleDropdownClose('empNm'),
        }
    ];

    return (
        <>
            <TitleBar data={StitchEntrylist} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stitching Entry(Contractor)</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={3.4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '20%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1} sx={{ mt: -1.5, mb: 0.5 }}>
                                        <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                            <FormLabel component="legend">Order Type:</FormLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl component="fieldset" fullWidth>
                                                <RadioGroup row name="ordType" value={formData.ordType} onChange={handleRadioChange}>
                                                    <FormControlLabel value="0" control={<Radio />} label="Manual" />
                                                    <FormControlLabel value="1" control={<Radio />} label="Sale Order" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.ordType === '1' &&
                                    (<Grid item xs={12} md={4.5}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="sono">Sale Order No:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="sono"
                                                        name="sono"
                                                        options={returnMemo?.solist || []}
                                                        getOptionLabel={(option) => option.sono || ''}
                                                        value={returnMemo?.solist?.find(item => item.sono === formData.sono) || null}
                                                        onChange={(event, newValue) =>
                                                            handleDropdownChange({
                                                                target: { name: 'sono', value: newValue ? newValue.sono : '' } // Ensure consistent controlled behavior
                                                            }, 'sono')
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Select an option"
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.sono === value.sono}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    )
                                }

                                {[
                                    { label: 'Stitching Memo', name: 'stitchNo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {formData.ordType === '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="reMemo">Cutting Item.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="reMemo"
                                                        name="reMemo"
                                                        options={reMemolist || []}
                                                        getOptionLabel={(option) => option.itemNm || ''}
                                                        value={reMemolist?.find(item => item.ID === formData.reMemo) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'reMemo', value: newValue ? newValue.ID : '' } }, 'reMemo')}
                                                        // onOpen={() => handleDropdownOpen('reMemo')}
                                                        // onClose={() => handleDropdownClose('reMemo')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>}

                                {formData.ordType === '1' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="reMemo">Cutting Item.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="reMemo"
                                                        name="reMemo"
                                                        options={Array.isArray(itemsSO) ? itemsSO : []}
                                                        getOptionLabel={(option) => option.itemNm || ''}
                                                        value={itemsSO?.find(item => item.ID === formData.reMemo) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'reMemo', value: newValue ? newValue.ID : '' } }, 'reMemo')}
                                                        // onOpen={() => handleDropdownOpen('reMemo')}
                                                        // onClose={() => handleDropdownClose('reMemo')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="empNm">Master Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="empNm"
                                                    name="empNm"
                                                    options={stemplist?.data2}
                                                    getOptionLabel={(option) => option.empNm || ''}
                                                    value={stemplist?.data2?.find(item => item.ID === formData.empNm) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm')}
                                                    onOpen={() => handleDropdownOpen('empNm')}
                                                    onClose={() => handleDropdownClose('empNm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistMaster && dropdownlistMaster?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='item'>Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='item'
                                                >
                                                    {formData.item || ''} 
                                                </Typography>
                                                {errors.item && <FormHelperText style={errorStyles}>{errors.item}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mclothNm'>Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='mclothNm'
                                                >
                                                    {formData.mclothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                                {errors.mclothNm && <FormHelperText style={errorStyles}>{errors.mclothNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.m1cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1clothNm'>Matching-1:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m1clothNm'
                                                    >
                                                        {formData.m1clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.m1clothNm && <FormHelperText style={errorStyles}>{errors.m1clothNm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.m2cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m2clothNm'>Matching-2:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m2clothNm'
                                                    >
                                                        {formData.m2clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.m2clothNm && <FormHelperText style={errorStyles}>{errors.m2clothNm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.m3cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1clothNm'>Matching-3:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m3clothNm'
                                                    >
                                                        {formData.m3clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.m3clothNm && <FormHelperText style={errorStyles}>{errors.m3clothNm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='cutMemo'>Cutting Memo.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='cutMemo'
                                                >
                                                    {formData.cutMemo || ''}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='cutrememo'>Cutting Rememo:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='cutrememo'
                                                >
                                                    {formData.cutrememo || ''}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='totQty'>Total Qty.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='totQty'
                                                >
                                                    {formData.totQty || ''}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* <Grid item xs={12} md={6}></Grid> */}


                                {itemData.length > 0 &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.size}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.rbqty}</TableCell>
                                                    )) : null}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={issueQtyValues[index] || '0'}
                                                                onChange={(e) => handleQtyChange('issue', index, e.target.value)}
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {balQtyValues[index] || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                <Grid item xs={12} md={6}>
                                    <div>
                                        {/* <h3>Material Entry </h3> */}
                                        <div className="button-group">
                                            <button className="add" onClick={handleAddlump}>Add</button>
                                            <button className="delete" onClick={handleRemoveLumps}>Remove</button>
                                            <button className="add" onClick={handlenavigateMaterial}>New Material</button>
                                        </div>
                                        <table style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Material Work</th>
                                                    <th>Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {material.map((mat, matIndex) => (
                                                    <>
                                                        <tr key={matIndex}>
                                                            <td><input
                                                                type="checkbox"
                                                                checked={mat.selected}
                                                                onChange={() => handleLumpSelection(matIndex)}
                                                            />{" "}
                                                                {matIndex + 1}
                                                            </td>
                                                            <td>
                                                                <DropdownWithBtn
                                                                    key={matIndex}
                                                                    id={matIndex} // Unique ID for each material
                                                                    options={Array.isArray(materiallist?.data) && materiallist?.data || []}
                                                                    value={mat.material} // Bind value dynamically
                                                                    onChange={(newValue) =>
                                                                        handleDropdownChange2(matIndex, newValue) // Pass matIndex and dropdown id
                                                                    }
                                                                    isDesktop={isDesktop}
                                                                    getOptionLabel={(option) => option.materialNm || ''}
                                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                                    valueFinder={(options, value) => {
                                                                        if (Array.isArray(options)) {
                                                                            return options.find(item => item.ID === value) || null;
                                                                        }
                                                                        return null;
                                                                    }}
                                                                    handleDropdownOpen={handleDropdownOpen}  // Pass `valueFinder` function here
                                                                    handleDropdownClose={handleDropdownClose}
                                                                />

                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    placeholder="qty"
                                                                    value={mat.qty}
                                                                    onChange={(e) => handleLumpColor(
                                                                        matIndex,
                                                                        e.target.value,
                                                                        "qty"
                                                                    )}
                                                                />
                                                            </td>


                                                        </tr>
                                                    </>
                                                ))}
                                                <tr>
                                                    <td> </td>
                                                    <td>
                                                        <span className="tot-lump">Total Qty</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmat}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Grid>

                                {[
                                    { label: 'Stitching Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleAddData}>Add</Button>
                                </Grid>

                                <table>
                                    <thead>
                                        <th>Sr.No.</th>
                                        {formData.sono !== '' && <th>Sale Order</th>}
                                        <th>Item</th>
                                        <th>Total Qty.</th>
                                        <th>Total material</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </thead>
                                    {
                                        allData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                {formData.sono !== '' && <td>{item.sono}</td>}
                                                <td>{item.itemNm}</td>
                                                <td>{item.totqty}</td>
                                                <td>{item.totmat}</td>
                                                <td><Preview className='cursor-pointer' onClick={() => handleViewClick(item)} /></td>
                                                <td><DeleteIcon className='cursor-pointer' onClick={() => handleDeleteItem(item)} /></td>
                                            </tr>
                                        ))
                                    }

                                </table>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StitchContEntry2;
